import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { CabinetPage } from './pages/CabinetPage';
import { StreamerBannerPage } from './pages/StreamerBannerPage';

export default function App() {
  return (
    <Routes>
      <Route path="/banner/:code" element={<StreamerBannerPage />} />
      <Route
        path="/login"
        element={
          <div className="container">
            <LoginPage />
          </div>
        }
      />
      <Route element={<ProtectedRoute />}>
        <Route index element={<CabinetPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
